.column {
	display: flex;
	flex-direction: column;
	gap: var(--size-8);
	align-self: stretch;
	min-height: 0;
	overflow-y: auto;
	/* keeps card shadows clear of the scroll container's edges without shifting the content */
	padding: var(--size-3);
	margin: calc(var(--size-3) * -1);

	> * {
		width: 100%;
		max-width: 50rem;
	}
}

.download {
	position: relative;
	isolation: isolate;
	overflow: clip;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	align-items: center;
	gap: var(--size-5) var(--size-7);
	padding: var(--size-7);
	border-radius: var(--radius-lg);
	background-color: var(--color-primary);
	color: var(--gray-100);

	color-scheme: dark;
	--theme: light;

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		z-index: -1;
		background: linear-gradient(rgb(from var(--gray-100) r g b / 15%), transparent);
		mask: url("../../../texture.svg") center / 1600px no-repeat;
	}
	
	@media (min-width: 600px) {
		flex-direction: row;
	}
}

.downloadCopy {
	flex: 1;
	min-width: 16rem;
	display: flex;
	flex-direction: column;
	gap: var(--size-2);
}

.downloadTitle {
	font-size: var(--text-subtitle-1);
	font-weight: 600;
}

.downloadBlurb {
	opacity: 0.75;
	text-wrap: pretty;
}

.downloadButton {
	color-scheme: light;
}

.downloadLabel {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}

.person {
	display: flex;
	align-items: center;
	gap: var(--size-2);
}

.empty {
	text-align: center;
	padding: var(--size-8);
}
